export const viewTypeList = [
  'create',
  'edit',
  'dashboard',
  'custom',
  'public',
  'index',
  'crud',
  'tabbed',
] as const;
export type ViewType = typeof viewTypeList[number];
